var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle"},[_c('p',{staticClass:"middle-left"},[_vm._v(" 备课要点 ")]),_c('p',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"middle-right"},[_vm._v(" "+_vm._s(_vm.curr + 1)+" / "+_vm._s(_vm.total)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }